import Analytics from "./util/Analytics";
import { markExperiments } from "shared/util/Experiment";
import * as Sentry from "@sentry/browser";
import { getQuery } from "analytics/util/helpers";

export const ENTRY_POINTS = {
	DT_MODAL: "doubletake modal",
	DISCOVERY_BANNER: "discovery banner",
	DETAILS_REBOARDING: "completed self detail reboarding",
	WIW_LINK: "profile tab ideal person link",
};
export const trackShownGlobalPreferenceEntryPoint = (entryPoint) => {
	const data = { location: entryPoint };
	Analytics.logUIEvent(Analytics.eventNames.globalPreferencesShownEntryPoint, { data });
};


export const VIEWDED_GP_SOURCES = {
	DT_MODAL: "doubletake modal",
	DISCOVERY_BANNER: "discovery banner",
	DETAILS_REBOARDING: "completed details reboarding",
	IDEAL_PERSON_LINK: "profile tab ideal person link",
	MATCH_SEARCH: "match search",
};

export const trackViewedGlobalPreferences = () => {
	const source = getQuery("source");

	if (!Object.values(VIEWDED_GP_SOURCES).includes(source)) {
		return;
	}

	const data = { source };
	Analytics.logUIEvent(Analytics.eventNames.globalPreferencesViewed, { data });
};

export const trackDismissedGlobalPreferenceModal = () => {
	Analytics.logUIEvent(Analytics.eventNames.globalPreferencesDismissedModal);
};

export const VIEWED_REBOARDING_SOURCES = {
	PROFILE: "self profile banner",
	IDEAL_PERSON: "my ideal person banner",
	DISABLED_PREFERENCE: "disabled preference",
};
export const trackEnteredSelfDetailsReboarding = (detailsRemaining) => {
	const source = getQuery("source");

	if (!Object.values(VIEWED_REBOARDING_SOURCES).includes(source)) {
		return;
	}

	const data = { "details remaining": detailsRemaining, source };
	Analytics.logUIEvent(Analytics.eventNames.globalPreferencesEnteredSelfDetailReboarding, { data });
};

export const trackCompletedDetailsReboarding = () => {
	Analytics.logUIEvent(Analytics.eventNames.globalPreferencesCompletedDetailsReboarding);
};

export const markSeenGlobalPreferenceExperiemnt = () => {
	return markExperiments(["GLOBAL_PREFS_AUSTRALIA"])
		.catch(Sentry.captureException);
};

export const trackSawSelfDetailsPrompt = (location) => {
	const data = { location };
	Analytics.logUIEvent(Analytics.eventNames.globalPreferencesSawSelfDetailPrompt, { data });
};



// WEBPACK FOOTER //
// ./src/analytics/globalPreferences.js